// types
import type { IConfigObj } from '@makemydeal/dr-common-utils';
import type { ChooseVehicleConfig, ChooseVehicleState, ChooseVehicleStateTree, Dealership } from '../types/stateTreeTypes';

export const getConfig = (state: ChooseVehicleStateTree): ChooseVehicleConfig => {
    return state.config;
};

export const getConfigServices = (state: ChooseVehicleStateTree) => {
    return getConfig(state).services;
};

export const getServicesBff = (state: ChooseVehicleStateTree): IConfigObj => {
    return getConfigServices(state).bff;
};

export const getChooseVehicle = (state: ChooseVehicleStateTree): ChooseVehicleState => {
    return state.chooseVehicle || {};
};

export const getCommonOrgId = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).commonOrgId || '';
};

export const isCostVisible = (): boolean => {
    return false;
};

export const getVehicleVin = (state: ChooseVehicleStateTree): string | undefined => {
    return getChooseVehicle(state).vin;
};

export const getStockNumber = (state: ChooseVehicleStateTree): string | undefined => {
    return getChooseVehicle(state).stockNumber;
};

export const getInitialSearchValue = (state: ChooseVehicleStateTree): string | undefined => {
    return getChooseVehicle(state).initialSearchValue;
};

export const getBridgeUserId = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).bridgeUser?.id || '';
};

export const getBridgeUserFullName = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).bridgeUser?.name || '';
};

export const getDealXgId = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).bridgeUser?.dealXgId || '';
};

export const getDealerName = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).dealerConfig?.dealerName || '';
};

export const getDealerId = (state: ChooseVehicleStateTree): string => {
    return getChooseVehicle(state).dealerConfig?.dealerId || '';
};

export const getDealerships = (state: ChooseVehicleStateTree): Dealership[] | undefined => {
    return getChooseVehicle(state).dealerships;
};

export const isEnableCrossDealershipAIVehicleSearch = (state: ChooseVehicleStateTree): boolean => {
    return state.featureToggles?.enableCrossDealershipAIVehicleSearch ?? false;
};

export const isPromptOptimizationEnabled = (state: ChooseVehicleStateTree): boolean => {
    return state.featureToggles?.F287702_Enable_Prompt_Optimization ?? false;
};

export const isSimilarityBodyStyleRelaxationEnabled = (state: ChooseVehicleStateTree): boolean => {
    return state.featureToggles?.DE783583_Enable_Similarity_BodyStyle_Relaxation ?? false;
};

export const isAgeOfInventorySearchEnabled = (state: ChooseVehicleStateTree): boolean => {
    return state.featureToggles?.F292323_Enable_Age_Of_Inventory_Search ?? false;
};
